import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles} from '../../../../../utils/styles';

const StyledTeam = styled(Space)`
  ${bordersStyles.default};
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 24px;
  width: 100%;

  & > .ant-space-item {
    width: 100%;
  }
`;

export {
  StyledTeam
}
